import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconUserCheck } from "@tabler/icons-react";
import { PersonalDef } from "./PersonalDef";

export const PersonalIcon = IconUserCheck;
export const PersonalHelpText = '* Aquí puede ver la lista de todo el personal.';

export class Personal extends Entity<PersonalDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalDef(), parentKeys);
        this.Form = import('./PersonalForm').then((module) => module.PersonalForm);
        this.Title = "Personal";
        this.Icon = PersonalIcon;
        this.HelpText = PersonalHelpText;
    }
}